export interface SslSettingsConfigState {
  is_valid: boolean,
    self_signed: boolean,
    ssl: boolean
}

export interface SslSettingsState {
  config: SslSettingsConfigState
}

const getInitialState = (): SslSettingsState => ({
  config: {
    is_valid: true,
    self_signed: true,
    ssl: true
  }
});

export const sslSettingsGetters: CommonGetterTree<SslSettingsState> = {
  config: state => state.config
};

export const sslSettingsMutations: CommonMutationTree<SslSettingsState> = {
  SET_CONFIG(state, config) {
    state.config = config;
  },
  FLUSH_STATE(state) {
    Object.assign(state, getInitialState());
  }
};

export const sslSettingsActions: CommonActionTree<SslSettingsState> = {
  FETCH_CONFIG({ commit }): Promise<FetchResponse> {
    return this.$api.get('/api/v2/ssl').then(({ data }) => {
      commit('SET_CONFIG', data);
      return data;
    });
  },
  SAVE(_, payload): Promise<UploadResponse> {
    return this.$api.upload('/api/v2/ssl', payload, {
      method: 'PUT'
    });
  }
};

export default new class implements CommonStore<any, unknown> {
  name = 'sslSettings';
  namespaced = true;
  state = getInitialState();
  getters = sslSettingsGetters;
  mutations = sslSettingsMutations;
  actions = sslSettingsActions;
}();
